import * as server from '../entries/pages/(admin)/admin/_page.server.ts.js';

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/+page.server.ts";
export const imports = ["_app/immutable/nodes/4.DzTw8yq4.js","_app/immutable/chunks/yI7QhVT-.js","_app/immutable/chunks/DdBbTIYF.js","_app/immutable/chunks/BT_zozEV.js","_app/immutable/chunks/BSTIXOHC.js","_app/immutable/chunks/sz5a-fN3.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/DMZiD_i_.js","_app/immutable/chunks/swn_N_sD.js"];
export const stylesheets = ["_app/immutable/assets/4.DleZyqak.css"];
export const fonts = [];
